<form
  name="userProfileForm"
  [formGroup]="userProfileForm"
  novalidate
  class="sales-company-profile"
  (ngSubmit)="formSubmit()"
>
  <div
    class="container-fluid p-0"
    [ngClass]="{ 'content-loading-disabled': isLoader }"
  >
    <!--<div class="loading-spinner-overlay" *ngIf="isLoader">
      <i class="fa fa-spinner fa-spin"></i>
    </div>-->
    <div class="bg-white p-4 mt-2">
      <div class="row">
        <div class="col-md-8 col-lg-9">
          <div class="title-wrap d-sm-flex">
            <div class="pr-2">
              <img [src]="logoImage" alt="logo Image" width="100" />
            </div>
            <div class="titles">
              <h6 class="ps-md-3 pt-2">
                <small>{{ userProfleModel?.locationText }}</small>
              </h6>
              <h3 class="ps-md-3">{{ userProfleModel?.displayName }}</h3>
              <!--<i class="fa fa-spinner fa-spin" *ngIf="isLoader"></i>-->
            </div>
          </div>
        </div>
      </div>

      <div class="mt-4">
        <div class="row form-row">
          <div class="col-md-8 col-xs-12">
            <div class="row">
              <div class="col-lg-6 col-sm-6 col-xs-12">
                <label class="col-form-label">Company Name</label>
                <div class="input-group mb-2">
                  <span class="input-group-text bg-white" id="basic-addon1">
                    <i class="fas fa-building"></i>
                  </span>
                  <input
                    type="text"
                    formControlName="organisation"
                    class="form-control"
                  />
                </div>
                <span
                  class="text-danger"
                  *ngIf="userProfileForm.hasError('required', 'organisation')"
                >
                  Field is required
                </span>
              </div>
              <div class="col-lg-6 col-sm-6 col-xs-12">
                <label class="col-form-label">Display Name</label>
                <div class="input-group mb-2">
                  <span class="input-group-text bg-white" id="basic-addon1">
                    <i class="fas fa-address-card"></i>
                  </span>
                  <input
                    type="text"
                    formControlName="displayName"
                    class="form-control"
                  />
                </div>
                <span
                  class="text-danger"
                  *ngIf="userProfileForm.hasError('required', 'displayName')"
                >
                  Field is required
                </span>
              </div>
              <div class="col-lg-6 col-sm-6 col-xs-12 mt-2">
                <label class="col-form-label">Location Name</label>
                <div class="input-group mb-2">
                  <span class="input-group-text bg-white" id="basic-addon1">
                    <i class="fas fa-map-marker-alt"></i>
                  </span>
                  <input
                    type="text"
                    formControlName="locationText"
                    class="form-control"
                  />
                </div>
                <span
                  class="text-danger"
                  *ngIf="userProfileForm.hasError('required', 'locationText')"
                >
                  Field is required
                </span>
              </div>
              <div class="col-lg-6 col-sm-6 col-xs-12 mt-2">
                <label class="col-form-label">Enquiry Email Address</label>
                <div class="input-group mb-2">
                  <span class="input-group-text bg-white" id="basic-addon1">
                    <i class="far fa-envelope-open"></i>
                  </span>
                  <input
                    type="email"
                    formControlName="enquiryEmailAddress"
                    class="form-control"
                  />
                </div>
                <span
                  class="text-danger"
                  *ngIf="
                    userProfileForm.get('enquiryEmailAddress').hasError('email')
                  "
                >
                  Please enter a valid email address
                </span>
                <span
                  class="text-danger"
                  *ngIf="
                    userProfileForm.hasError('required', 'enquiryEmailAddress')
                  "
                >
                  Field is required
                </span>
              </div>
            </div>
          </div>
          <div class="col-md-4 col-xs-12">
            <div class="row">
              <div class="col-lg-6 col-sm-6 col-xs-12">
                <label class="d-block">Logo Image</label>
                <div class="avatar-upload">
                  <div class="avatar-edit">
                    <input
                      type="file"
                      id="logoImage"
                      accept=".png, .jpg, .jpeg"
                      #fileInput
                      (change)="uploadFile($event)"
                    />
                  </div>
                  <div class="avatar-preview">
                    <img id="imagePreview" [src]="logoImage" />
                  </div>
                  <div class="closeBtn">
                    <label
                      class="fa fa-camera btn-img"
                      (click)="fileInput.click()"
                      role="button"
                    ></label>
                  </div>
                </div>
              </div>
              <div class="col-lg-6 col-sm-6 col-xs-12">
                <label class="d-block">Hero Image</label>

                <div class="avatar-header-upload">
                  <div class="avatar-edit">
                    <input
                      type="file"
                      id="headerImage"
                      accept=".png, .jpg, .jpeg"
                      #headerFileInput
                      (change)="uploadHeaderFile($event)"
                    />
                  </div>
                  <div class="avatar-preview">
                    <img id="headerImagePreview" [src]="headerImage" />
                  </div>
                  <div class="closeBtn">
                    <label
                      class="fa fa-camera btn-img"
                      (click)="headerFileInput.click()"
                      role="button"
                    ></label>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="row form-row">
          <div class="col-md-12 mt-2">
            <label class="col-form-label">Home Text</label>
            <div class="input-group mb-2">
              <span class="input-group-text bg-white" id="basic-addon1">
                <i class="fas fa-paragraph mt-1"></i>
              </span>
              <textarea
                formControlName="homeText"
                cols="30"
                rows="6"
                class="form-control"
              >
              </textarea>
            </div>            
          </div>
          <div class="col-md-12 mt-2">
            <label class="col-form-label">Home Video URL</label>
            <div class="input-group mb-2">
              <span class="input-group-text bg-white" id="basic-addon1">
                <i class="fas fa-link mt-1"></i>
              </span>
              <textarea
                formControlName="homeVideoEmbedUrl"
                placeholder="Use Embed Video Url"
                cols="30"
                rows="1"
                class="form-control"
              >
              </textarea>
            </div>
            <span
              class="text-danger"
              *ngIf="userProfileForm.hasError('required', 'homeVideoEmbedUrl1')"
            >
              Field is required
            </span>
          </div>
          <div class="col-md-12 mt-2">
            <label class="col-form-label">About Text</label>
            <div class="input-group mb-2">
              <span class="input-group-text bg-white" id="basic-addon1">
                <i class="fas fa-paragraph mt-1"></i>
              </span>
              <textarea
                formControlName="aboutText"
                cols="30"
                rows="6"
                class="form-control"
              >
              </textarea>
            </div>
            <span
              class="text-danger"
              *ngIf="userProfileForm.hasError('required', 'aboutText')"
            >
              Field is required
            </span>
          </div>
          <div class="col-md-12 mt-2">
            <label class="col-form-label">About Video URL</label>
            <div class="input-group mb-2">
              <span class="input-group-text bg-white" id="basic-addon1">
                <i class="fas fa-link mt-1"></i>
              </span>
              <textarea
                formControlName="aboutVideoEmbedUrl"
                placeholder="Use Embed Video Url"
                cols="30"
                rows="1"
                class="form-control"
              >
              </textarea>
            </div>
            <span
              class="text-danger"
              *ngIf="
                userProfileForm.hasError('required', 'aboutVideoEmbedUrl1')
              "
            >
              Field is required
            </span>
          </div>
          <div class="col-md-12 mt-2">
            <label class="col-form-label">Address 1</label>
            <div class="input-group mb-2">
              <span class="input-group-text bg-white" id="basic-addon1">
                <i class="fas fa-location-arrow"></i>
              </span>
              <textarea
                formControlName="address"
                placeholder="Address"
                cols="30"
                rows="2"
                class="form-control"
              >
              </textarea>
            </div>
            <span
              class="text-danger"
              *ngIf="userProfileForm.hasError('required', 'address')"
            >
              Field is required
            </span>
          </div>
          <div class="col-md-12 mt-2">
            <label class="col-form-label">Address 2</label>
            <div class="input-group mb-2">
              <span class="input-group-text bg-white" id="basic-addon1">
                <i class="fas fa-location-arrow"></i>
              </span>
              <textarea
                formControlName="addressLine2"
                placeholder="Address 2"
                cols="30"
                rows="2"
                class="form-control"
              >
              </textarea>
            </div>
            <span
              class="text-danger"
              *ngIf="userProfileForm.hasError('required', 'addressLine2')"
            >
              Field is required
            </span>
          </div>

          <div class="col-lg-4 col-sm-6 mt-2">
            <label class="col-form-label">City/Suburb</label>
            <div class="input-group mb-2">
              <span class="input-group-text bg-white" id="basic-addon1">
                <i class="far fa-building"></i>
              </span>
              <input
                type="text"
                formControlName="suburb"
                placeholder="Suburb"
                class="form-control"
              />
            </div>
            <span
              class="text-danger"
              *ngIf="userProfileForm.hasError('required', 'suburb')"
            >
              Field is required
            </span>
          </div>
          <div class="col-lg-4 col-sm-6 mt-2">
            <label class="col-form-label">State</label>
            <div class="input-group mb-2">
              <span class="input-group-text bg-white" id="basic-addon1">
                <i class="fas fa-globe"></i>
              </span>
              <input
                type="text"
                formControlName="stateName"
                placeholder="State"
                class="form-control"
              />
            </div>
            <span
              class="text-danger"
              *ngIf="userProfileForm.hasError('required', 'stateName')"
            >
              Field is required
            </span>
          </div>
          <div class="col-lg-4 col-sm-6 mt-2">
            <label class="col-form-label">Post/Zip Code</label>
            <div class="input-group mb-2">
              <span class="input-group-text bg-white" id="basic-addon1">
                <i class="fas fa-mail-bulk"></i>
              </span>
              <input
                type="number"
                formControlName="postCode"
                placeholder="Post/Zip Code"
                class="form-control"
              />
            </div>
            <span
              class="text-danger"
              *ngIf="userProfileForm.hasError('required', 'postCode')"
            >
              Field is required
            </span>
          </div>
          <div class="col-lg-4 col-sm-6 mt-2">
            <label class="col-form-label">Country</label>
            <div class="input-group mb-2">
              <span class="input-group-text bg-white" id="basic-addon1">
                <i class="far fa-flag"></i>
              </span>
              <select
                *ngIf="countries.length > 0"
                class="form-select"
                id="basic-addon1"
                formControlName="countryName"
                [ngModelOptions]="{ standalone: true }"
                [ngClass]="{
                  'border border-danger ':
                    submitted &&
                    userProfileForm.hasError('required', 'countryName')
                }"
              >
                <option value="">Select Country...</option>
                <option
                  *ngFor="let country of countries"
                  value="{{ country?.countryName }}"
                >
                  {{ country?.countryName }}
                </option>
              </select>
            </div>
            <span
              class="text-danger"
              *ngIf="userProfileForm.hasError('required', 'countryName')"
            >
              Field is required
            </span>
          </div>

          <div class="col-lg-4 col-sm-6 mt-2">
            <label class="col-form-label">Phone Number</label>


            <div class="input-group" style="width: 100%;">
              <span class="input-group-text bg-white">
                <i class="fas fa-phone"></i>
              </span>

              <div class="flex-grow-1">                  
                  <ngx-intl-tel-input [cssClass]="'form-control'"
                                      [preferredCountries]="preferredCountries"
                                      [enableAutoCountrySelect]="true"
                                      [enablePlaceholder]="true"
                                      [searchCountryFlag]="true"
                                      [searchCountryField]="[
                                        SearchCountryField.Iso2,
                                        SearchCountryField.Name,
                                        SearchCountryField.DialCode
                                      ]"
                                      [selectFirstCountry]="false"
                                      [selectedCountryISO]="userProfileForm.get('selectedPNCountryISO')?.value"
                                      [maxLength]="15"
                                      [phoneValidation]="true"
                                      [separateDialCode]="true"
                                      [numberFormat]="PhoneNumberFormat.National"
                                      name="phoneNumber"
                                      formControlName="phoneNumberControl">
                  </ngx-intl-tel-input>
              </div>
            </div>

            <!--<span class="text-danger"
                  *ngIf="userProfileForm.get('phoneNumber').invalid">
              Only digits (0-9) are allowed.
            </span>-->
            <span class="text-danger"
                  *ngIf="userProfileForm.hasError('required', 'phoneNumber')">
              Field is required
            </span>

            <!--<div class="input-group mb-2">
    <span class="input-group-text bg-white" id="basic-addon1">
      <i class="fas fa-phone"></i>
    </span>
    <input type="text"
           formControlName="phoneNumber"
           placeholder="Phone Number"
           class="form-control" />
  </div>-->

          </div>

          <div class="col-lg-4 col-sm-6 mt-2">
            <label class="col-form-label">Fax Number</label>
            <div class="input-group" style="width: 100%;">
              <span class="input-group-text bg-white">
                <i class="fas fa-fax"></i>
              </span>

              <div class="flex-grow-1">
                <ngx-intl-tel-input [cssClass]="'form-control'"
                                    [preferredCountries]="preferredCountries"
                                    [enableAutoCountrySelect]="true"
                                    [enablePlaceholder]="true"
                                    [searchCountryFlag]="true"
                                    [searchCountryField]="[
                    SearchCountryField.Iso2,
                    SearchCountryField.Name,
                    SearchCountryField.DialCode
                  ]"
                                    [selectFirstCountry]="false"
                                    [selectedCountryISO]="userProfileForm.get('selectedFNCountryISO')?.value"
                                    [maxLength]="15"
                                    [phoneValidation]="true"
                                    [separateDialCode]="true"
                                    [numberFormat]="PhoneNumberFormat.National"
                                    name="faxNumber"
                                    formControlName="faxNumberControl">
                </ngx-intl-tel-input>
              </div>
            </div>
              <span class="text-danger"
                    *ngIf="userProfileForm.hasError('required', 'faxNumber')">
                Field is required
              </span>
            </div>

          <div class="col-lg-3 col-sm-6 mt-2">
            <label class="col-form-label">Website URL</label>
            <div class="input-group mb-2">
              <span class="input-group-text bg-white" id="basic-addon1">
                <i class="fas fa-globe-asia"></i>
              </span>
              <input
                type="text"
                formControlName="websiteUrl"
                placeholder="Company Website Url"
                class="form-control"
              />
            </div>
            <span
              class="text-danger"
              *ngIf="userProfileForm.hasError('required', 'websiteUrl')"
            >
              Field is required
            </span>
          </div>
          <div class="col-lg-3 col-sm-6 mt-2">
            <label class="col-form-label">Facebook URL</label>
            <div class="input-group mb-2">
              <span class="input-group-text bg-white" id="basic-addon1">
                <i class="fab fa-facebook-f"></i>
              </span>
              <input
                type="text"
                formControlName="facebookUrl"
                placeholder="Facebook Page Url"
                class="form-control"
              />
            </div>
            <span
              class="text-danger"
              *ngIf="userProfileForm.hasError('required', 'facebookUrl')"
            >
              Field is required
            </span>
          </div>
          <div class="col-lg-3 col-sm-6 mt-2">
            <label class="col-form-label">Twitter Handle</label>
            <div class="input-group mb-2">
              <span class="input-group-text bg-white" id="basic-addon1">
                <i class="fab fa-twitter"></i>
              </span>
              <input
                type="text"
                formControlName="twitterHandle"
                placeholder="Twitter Handle"
                class="form-control"
              />
            </div>
            <span
              class="text-danger"
              *ngIf="userProfileForm.hasError('required', 'twitterHandle')"
            >
              Field is required
            </span>
          </div>
          <div class="col-lg-3 col-sm-6 mt-2">
            <label class="col-form-label">Instagram Handle</label>
            <div class="input-group mb-2">
              <span class="input-group-text bg-white" id="basic-addon1">
                <i class="fab fa-instagram"></i>
              </span>
              <input
                type="text"
                formControlName="instagramHandle"
                placeholder="Instagram Handle"
                class="form-control"
              />
            </div>
            <span
              class="text-danger"
              *ngIf="userProfileForm.hasError('required', 'instagramHandle')"
            >
              Field is required
            </span>
          </div>
          <div class="col-lg-4 col-sm-6 mt-2">
            <label class="col-form-label">Sms Number</label>
            <div class="input-group mb-2">
              <span class="input-group-text bg-white" id="basic-addon1">
                <i class="fas fa-phone"></i>
              </span>
              <input type="text"
                     formControlName="smsNumber"
                     placeholder="Sms Number"
                     class="form-control"
                     readonly
                     [disabled]="true" />
            </div>
          </div>
          <div class="col-lg-4 col-sm-6 mt-2">
            <label class="col-form-label">Reply To Email Address</label>
            <div class="input-group mb-2">
              <span class="input-group-text bg-white" id="basic-addon1">
                <i class="far fa-envelope-open"></i>
              </span>
              <input
                type="email"
                formControlName="replyToEmailAddress"
                class="form-control"
                [ngClass]="{
                  'border border-danger': userProfileForm.get(
                    'replyToEmailAddress'
                  ).invalid
                }"
              />
            </div>
          </div>

          <div class="col-lg-3 col-sm-6 mt-md-3">
            <label class="mb-md-4"></label>
            <div class="form-check">
              <input
                class="form-check-input"
                type="checkbox"
                formControlName="isShowOnWebsite"
              />
              <label class="form-check-label" for="isShowOnWebsite">
                Show On Website
              </label>

              <span
                class="text-danger"
                *ngIf="userProfileForm.hasError('required', 'isShowOnWebsite')"
              >
                Field is required
              </span>
            </div>
          </div>
        </div>

        <div class="row" *ngIf="!isLoader && isUseBuiltInSave">
          <div class="col-12 text-end pt-3">
            <button
              type="button"
              class="btn btn-secondary me-2"
              routerLink="/sales"
              [disabled]="submitted"
            >
              <i class="fa fa-times"></i> Cancel
            </button>
            <button
              type="submit"
              class="btn btn-primary"
              [disabled]="submitted"
            >
              <i class="fa fa-save"></i> Save
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</form>
